<td
    class="member-cell"
    [class.nonreporting]="
        member.isCurrentlyReporting !== true &&
        activeView == ACTIVE_TAB_VIEW.TEAM
    "
    (click)="forceOADetails($event, true)"
    [colSpan]="member.active === true ? activecolumns : 1"
>
    <div
        class="member-name-container row text-left d-flex justify-content-start align-items-center"
        style="position: relative"
    >
        <cmps-icon
            class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
            [class.col-2]="rowExpanded !== true"
            [class.active]="member.active === true"
            [svgIcon]="
                member.active !== true ? 'chevron-right' : 'chevron-down'
            "
        ></cmps-icon>
        <span
            class="member-name"
            [ngClass]="{
                active: member.active === true,
                'col-10': rowExpanded != true
            }"
        >
            <span
                class="photo-name-sec"
                [ngClass]="{ 'photo-name-width': rowExpanded != true }"
            >
                <cmps-icon
                    class="user-icon"
                    svgIcon="account-circle"
                ></cmps-icon>
                <span
                    #performerdetail="ngbTooltip"
                    [ngbTooltip]="membertooltip"
                    tooltipClass="oa-widget-tooltip"
                    (mouseover)="getPerformerTooltip(performerdetail)"
                    placement="right"
                    container="body"
                >
                    {{ member.firstName | titlecase }}
                    {{ member.lastName | titlecase }}
                </span>
            </span>

            <span *ngIf="member.active == true">
                <span
                    *ngIf="member.supergroupName"
                    class="member-supergroup-name pl-2"
                    >- {{ i18n._67_SUPERGROUP | translate }}:
                    {{ member.supergroupName }}</span
                >
                <span class="member-name-close">
                    <cmps-icon svgIcon="close"></cmps-icon>
                </span>
            </span>
        </span>
    </div>
</td>

<ng-container *ngIf="member.active != true">
    <ng-container *ngFor="let col of columns | async; let index">
        <ng-container *ngIf="col.templateName !== null">
            <ng-container
                *ngTemplateOutlet="
                    {
                        oascore: oascore,
                        coachedopps: coachedopps,
                        uncoachedopps: uncoachedopps,
                        nonopps: nonopps,
                        nonkpi: nonkpi,
                        missedopps: missedopps
                    }[col.templateName];
                    context: { col: col }
                "
            ></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<!-- column templates-->
<ng-template
    #oascore
    let-col="col"
>
    <td
        class="overall-coaching-score"
        [ngClass]="col.class"
        *ngIf="col.active == true && member.active === false"
    >
        <button
            type="button"
            [style.color]="member.oaThreshold"
            class="non-button"
            #oascore="ngbTooltip"
            tooltipClass="oa-widget-tooltip"
            [ngbTooltip]="scoretooltip"
            triggers="manual"
            (click)="toggleScoreTooltip(oascore, member)"
            (blur)="toggleScoreTooltip(oascore)"
            placement="top"
            container="body"
        >
            <ng-container *ngIf="member.oaScore != null; else noScore">
                {{ member.oaScore }}
                <span class="score-percentage">%</span>
            </ng-container>
            <ng-template #noScore>-</ng-template>
        </button>
    </td>
</ng-template>

<ng-template
    #coachedopps
    let-col="col"
>
    <td
        class="member-oa"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.coached.length"
            [metrics]="member.coached"
            [dimensionIndex]="col.index"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.coached.length"
            class="nonkpi-button"
            #c="ngbTooltip"
            [ngbTooltip]="collapsedCoachedTooltip"
            tooltipClass="oa-widget-tooltip collapse-tooltip"
            triggers="manual"
            (click)="getOppListTooltip(c, member.coached, col.header)"
            placement="left"
        >
            <span>{{ member.coached.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #uncoachedopps
    let-col="col"
>
    <td
        class="member-oa uncoached"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.uncoached.length"
            [dimensionIndex]="col.index"
            [metrics]="member.uncoached"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.uncoached.length"
            class="nonkpi-button"
            #u="ngbTooltip"
            [ngbTooltip]="collapsedCoachedTooltip"
            tooltipClass="oa-widget-tooltip collapse-tooltip"
            triggers="manual"
            (click)="getOppListTooltip(u, member.uncoached, col.header)"
            placement="left"
        >
            <span>{{ member.uncoached.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #missedopps
    let-col="col"
>
    <td
        class="member-missed"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.missed.length"
            [dimensionIndex]="col.index"
            [metrics]="member.missed"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.missed?.length"
            class="nonkpi-button"
            #g="ngbTooltip"
            [ngbTooltip]="missedOppsTooltip"
            tooltipClass="oa-widget-tooltip collapse-tooltip"
            triggers="manual"
            (click)="getMissedOppsTooltip(g)"
            placement="left"
        >
            <span>{{ member.missed?.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #nonopps
    let-col="col"
>
    <td
        class="member-nonoa"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.nonoa.length"
            [dimensionIndex]="col.index"
            [metrics]="member.nonoa"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.nonoa.length"
            class="nonkpi-button"
            #h="ngbTooltip"
            [ngbTooltip]="collapsedCoachedTooltip"
            tooltipClass="oa-widget-tooltip collapse-tooltip"
            triggers="manual"
            (click)="getOppListTooltip(h, member.nonoa, col.header)"
            placement="left"
        >
            <span>{{ member.nonoa.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #nonkpi
    let-col="col"
>
    <td
        class="member-non-kpi"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <button
            *ngIf="member.nonKPICoaching"
            class="nonkpi-button"
            (click)="
                activetab = 'tab-performance';
                openedWithNonKPIButton.emit(true);
                forceOADetails($event)
            "
            #k="ngbTooltip"
            [ngbTooltip]="nonkpitooltip"
            tooltipClass="oa-widget-tooltip non-kpi-tooltip-left"
            (mouseover)="getNonKPITooltip(k, member.nonKpiCommitments)"
            placement="left"
            container="body"
        >
            <cmps-icon svgIcon="account-multiple"></cmps-icon>
            <span>{{ member.nonKPICoaching }}</span>
        </button>
    </td>
</ng-template>

<!-- hover templates -->
<ng-template
    #scoretooltip
    let-member="member"
>
    <div class="custom-tooltip oatooltip">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7370_EXPECTED_COACHING | translate }}</th>
                    <td>{{ member.expectedOpportunities }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7371_COACHED_OPPORTUNITIES | translate }}</th>
                    <td>{{ member.coachedOpportunities }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7372_TOTAL_OPPORTUNITIES | translate }}</th>
                    <td>{{ member.totalOpportunities }}</td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    #nonkpitooltip
    let-nonkpicommitments="nonkpicommitments"
>
    <div class="custom-tooltip nonkpitooltip">
        <div class="metric-mini-view">
            <table>
                <tr
                    *ngFor="
                        let nonkpi of nonkpicommitments;
                        let index = index;
                        trackBy: identifyNonKPIObject(index, nonkpi)
                    "
                    class="metric-view-divider"
                >
                    <td>
                        <div class="nonkpi-tooltip-behaviour">
                            {{ nonkpi.behaviour }}
                        </div>
                        <div class="nonkpi-tooltip-subbehaviour">
                            {{ nonkpi.subbehaviour }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    #membertooltip
    let-memberdata="memberdata"
>
    <div class="custom-tooltip offset-right memberdata">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <td>{{ i18n._7373_SUPERGROUP_NAME | translate }}</td>
                    <td>{{ member.supergroupName }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._7374_DAYS_IN_SUPERGROUP | translate }}</td>
                    <td>{{ member.supergroupAge }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._48_MANAGER | translate }}</td>
                    <td>{{ member.managerName }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._59_ROLE | translate }}</td>
                    <td>{{ member.roleName }}</td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    #missedOppsTooltip
    let-missedopps="missedopps"
>
    <div class="custom-tooltip interactive-tooltip missedoppstooltip">
        <div class="metric-mini-view">
            <div class="missed-opps-title">
                {{ i18n._7508_MISSED_OPPORTUNITIES | translate }}
            </div>
            <ul class="missed-opps-list">
                <ng-container *ngFor="let opp of missedopps; let i = index">
                    <li class="metric-links">
                        <metric-button
                            metricBtn
                            [opportunity]="opp"
                            (clicked)="setActiveMember($event)"
                            (click)="$event.stopPropagation()"
                        >
                        </metric-button>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</ng-template>

<!-- WITH COLLAPSED COLUMN BUTTONS -->
<ng-template
    #collapsedCoachedTooltip
    let-opps="opps"
    let-title="title"
>
    <div class="custom-tooltip interactive-tooltip missedoppstooltip">
        <div class="metric-mini-view">
            <div class="missed-opps-title">{{ title }}</div>
            <ul class="missed-opps-list">
                <ng-container *ngFor="let opp of opps; let i = index">
                    <li class="metric-links">
                        <metric-button
                            metricBtn
                            [opportunity]="opp"
                            (clicked)="setActiveMember($event)"
                            (click)="$event.stopPropagation()"
                        >
                        </metric-button>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</ng-template>
